module.exports = __webpack_public_path__ + "img/be.27d8ca49.svg";